import { useEffect, useState } from 'react';

import { useTranslationText } from 'Shared/Translation';

import ILoaderProps from './ILoaderProps';

const Loader: React.FunctionComponent<ILoaderProps> = (props: ILoaderProps) => {
  const [timer, setTimer] = useState(false);

  const [translation] = useTranslationText();
  const defaultMessage = translation('DEFAULT_LOADING_MESSAGE');

  useEffect(() => {
    const timer = setTimeout(() => setTimer(true), 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <div className={`loading  ${props.active && timer ? 'show' : ''}`}>
        <div className='loading-content'>{props.message ?? defaultMessage}</div>
      </div>
    </>
  );
};

export default Loader;
